import { useQuery } from '@tanstack/react-query';
import { AI_API } from 'utils/globalApiServices';
import Organization from 'infrastructure/Organization';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const queryFn = async ({ assignment_uuid, scenario_uuid, response_uuid }) => {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `/orgs/${org_id}/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/responses/${response_uuid}/transcription/`;
  const { data } = await AI_API.get(url);
  return data || [];
};

function formatTimestamp(timestamp) {
  const totalSeconds = parseFloat(timestamp);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const wholeSeconds = Math.floor(seconds);
  const milliseconds = Math.round((seconds - wholeSeconds) * 100);

  const formattedSeconds = String(wholeSeconds).padStart(2, '0');
  const formattedMilliseconds = String(milliseconds).padStart(2, '0');

  return `${minutes}:${formattedSeconds}:${formattedMilliseconds}`;
}

const useGetAssignmentTranscriptionQuery = ({
  assignment_uuid,
  scenario_uuid,
  response_uuid,
  enabled,
  clientName,
  userName,
}) => {
  const { setRealPlayTranscription } = useRealplayStore();
  return useQuery({
    queryFn: () => queryFn({ assignment_uuid, scenario_uuid, response_uuid }),
    queryKey: ['ASSIGNMENT_TRANSCRIPTION', assignment_uuid, scenario_uuid, response_uuid],
    enabled,
    onSuccess: (response) => {
      const realPlayTranscription = response?.map((r) => ({
        ...r,
        timestamp: formatTimestamp(r?.timestamp),
        name: r?.role === 'user' ? userName : clientName,
      }));
      setRealPlayTranscription(realPlayTranscription);
    },
    onError: () => {
      setRealPlayTranscription([]);
    },
  });
};

export default useGetAssignmentTranscriptionQuery;
